import React, { useState } from 'react'
import { Dialog, DialogContent } from '@mui/material'
import { t } from 'i18next'

const DeleteQuickListModal = ({
  showModalDeleteQuickList,
  setShowModalDeleteQuickList,
  handleConfirmDeleteQuickList,
}) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const confirmDelete = async () => {
    if (isDeleting) return
    setIsDeleting(true)
    try {
      await handleConfirmDeleteQuickList()
    } finally {
      setIsDeleting(false)
    }
  }

  const onClose = () => {
    setShowModalDeleteQuickList(false)
  }

  return (
    <Dialog
      open={showModalDeleteQuickList}
      onClose={onClose}
      maxWidth="xs"
      data-testid="modal-delete-quick-list">
      <DialogContent className="quick-list-preview">
        <div>
          <div className="delete-quick-list-confirmation-message">
            <p className="delete-quick-list-confirmation-text">
              {t('QUICK_LIST_SETTINGS.LIST.DELETE_CONFIRM_TEXT')}
            </p>
          </div>
          <div className="delete-quick-list-modal-buttons">
            <button
              data-testid="btn-confirm-delete-quick-list"
              onClick={confirmDelete}
              disabled={isDeleting}
              className="btn modal-si">
              {t('QUICK_LIST_SETTINGS.LIST.CONTINUE_OPTION')}
            </button>
            <button
              data-testid="btn-cancel-delete-quick-list"
              onClick={onClose}
              disabled={isDeleting}
              className="btn modal-no">
              {t('QUICK_LIST_SETTINGS.LIST.CANCEL_OPTION')}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteQuickListModal
